import React, { useEffect, useState } from 'react';
import axios from "axios";
import { Link, useParams } from "react-router-dom";

const Abiliti = () => {
    const { url: urlO } = useParams();
    const urlOfAbiliti = decodeURIComponent(urlO);
    const [abiliti, setAbiliti] = useState(null);

    useEffect(() => {
        axios.get(urlOfAbiliti)
            .then(res => setAbiliti(res.data))
            .catch(err => console.error(err));
    }, [urlOfAbiliti]);

    if (!abiliti) return <h1 className="text-center mt-10 text-gray-500">Načítání schopnosti...</h1>;

    return (
        <div className="max-w-2xl mx-auto mt-10 p-4 bg-white rounded shadow space-y-4">
            <h1 className="text-2xl font-bold">{abiliti.name}</h1>
            <p>{abiliti.flavor_text_entries.find(e => e.language.name === "en")?.flavor_text || "Bez popisu."}</p>

            <div className={"pb-4 "}>
                <h2 className="text-lg font-semibold">Pokemons with same ability</h2>
                <ul className="list-none flex flex-wrap ">
                    {abiliti.pokemon.map((item, i) => {

                        return (
                            <li key={i} className={"min-w-40 max-w-40 border rounded-lg shadow-md font-mono  text-black bg-white p-4 flex flex-col items-center text-center space-y-2 hover:scale-110"} >
                                <Link to={`/pokemons/${item.pokemon.name}`} className="text-black   ">
                                    {item.pokemon.name}
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </div>

            <Link to="/pokemons">
                <button className="bg-gray-300 px-4 py-1 rounded hover:bg-gray-400">Zpět</button>
            </Link>
        </div>
    );
};

export default Abiliti;
